"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxLiabilityReportCreate = exports.TaxLiabilityReportTransport = exports.TaxLiabilityReportItem = exports.TaxJurisdictionTypeLabel = exports.TaxJurisdictionType = exports.TaxJurisdictionTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.TaxJurisdictionTypes = ['STATE', 'COUNTY', 'CITY'];
exports.TaxJurisdictionType = typebox_1.Type.Union(exports.TaxJurisdictionTypes.map((type) => typebox_1.Type.Literal(type)));
exports.TaxJurisdictionTypeLabel = {
    STATE: 'State',
    COUNTY: 'County',
    CITY: 'City',
};
exports.TaxLiabilityReportItem = typebox_1.Type.Object({
    jurisdiction: typebox_1.Type.String(),
    taxRate: typebox_1.Type.Number(),
    taxableRevenue: typebox_1.Type.Integer(),
    taxAmount: typebox_1.Type.Integer(),
    jurisdictionType: typebox_1.Type.Union([typebox_1.Type.Literal('STATE'), typebox_1.Type.Literal('COUNTY'), typebox_1.Type.Literal('CITY')]),
    parentJurisdiction: typebox_1.Type.String(),
});
exports.TaxLiabilityReportTransport = typebox_1.Type.Object({
    reportTimeStamp: typebox_1.Type.String({
        format: 'date-time',
    }),
    jurisdictions: typebox_1.Type.Array(exports.TaxLiabilityReportItem),
    totalRevenue: typebox_1.Type.Integer(),
    totalNonTaxableRevenue: typebox_1.Type.Integer(),
    totalTaxableRevenue: typebox_1.Type.Integer(),
    totalBreakdownTaxAmount: typebox_1.Type.Integer(),
    totalNonBreakdownTaxAmount: typebox_1.Type.Integer(),
    totalTaxAmount: typebox_1.Type.Integer(),
});
exports.TaxLiabilityReportCreate = typebox_1.Type.Object({
    startDate: typebox_1.Type.String({ format: 'date' }),
    endDate: typebox_1.Type.String({ format: 'date' }),
});
//# sourceMappingURL=tax-liability-report.js.map